import { useTranslation } from 'react-i18next'

interface StepsProps {
  current: number
  total: number
  className?: string
}

export function Steps({ current, total, className = '' }: StepsProps) {
  const { t } = useTranslation()

  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <span className='text-body-sm font-medium text-cencert-header-blue'>
        {t('components.steps.step', { current, total })}
      </span>
      <div className='flex gap-0.5'>
        {Array.from({ length: total }, (_, index) => (
          <div
            key={index}
            className={`w-5 h-1.5 rounded-lg ${
              index < current ? 'bg-cencert-blue' : 'bg-gray-300'
            }`}
          />
        ))}
      </div>
    </div>
  )
}
